/** Approximate country centroids for ISO 3166-1 alpha-2 (geoip-lite session country). */
export const COUNTRY_CENTROIDS = {
  AD: [42.55, 1.58], AE: [23.42, 53.85], AF: [33.94, 67.71], AL: [41.15, 20.17],
  AM: [40.07, 45.04], AR: [-38.42, -63.62], AT: [47.52, 14.55], AU: [-25.27, 133.78],
  AZ: [40.14, 47.58], BA: [43.92, 17.68], BD: [23.68, 90.36], BE: [50.50, 4.47],
  BG: [42.73, 25.49], BH: [25.93, 50.64], BO: [-16.29, -63.59], BR: [-14.24, -51.93],
  BY: [53.71, 27.95], CA: [56.13, -106.35], CH: [46.82, 8.23], CL: [-35.68, -71.54],
  CN: [35.86, 104.20], CO: [4.57, -74.30], CR: [9.75, -83.75], CY: [35.13, 33.43],
  CZ: [49.82, 15.47], DE: [51.17, 10.45], DK: [56.26, 9.50], DZ: [28.03, 1.66],
  EC: [-1.83, -78.18], EE: [58.60, 25.01], EG: [26.82, 30.80], ES: [40.46, -3.75],
  ET: [9.15, 40.49], FI: [61.92, 25.75], FR: [46.23, 2.21], GB: [55.38, -3.44],
  GE: [42.32, 43.36], GH: [7.95, -1.02], GR: [39.07, 21.82], GT: [15.78, -90.23],
  HK: [22.40, 114.11], HR: [45.10, 15.20], HU: [47.16, 19.50], ID: [-0.79, 113.92],
  IE: [53.14, -7.69], IL: [31.05, 34.85], IM: [54.24, -4.55], IN: [20.59, 78.96],
  IQ: [33.22, 43.68], IR: [32.43, 53.69], IS: [64.96, -19.02], IT: [41.87, 12.57],
  JM: [18.11, -77.30], JO: [30.59, 36.24], JP: [36.20, 138.25], KE: [-0.02, 37.91],
  KR: [35.91, 127.77], KW: [29.31, 47.48], KZ: [48.02, 66.92], LB: [33.85, 35.86],
  LK: [7.87, 80.77], LT: [55.17, 23.88], LU: [49.82, 6.13], LV: [56.88, 24.60],
  LY: [26.34, 17.23], MA: [31.79, -7.09], MC: [43.74, 7.42], MD: [47.41, 28.37],
  ME: [42.71, 19.37], MK: [41.61, 21.75], MT: [35.94, 14.38], MX: [23.63, -102.55],
  MY: [4.21, 101.98], NG: [9.08, 8.68], NL: [52.13, 5.29], NO: [60.47, 8.47],
  NP: [28.39, 84.12], NZ: [-40.90, 174.89], OM: [21.47, 55.98], PA: [8.54, -80.78],
  PE: [-9.19, -75.02], PH: [12.88, 121.77], PK: [30.38, 69.35], PL: [51.92, 19.15],
  PT: [39.40, -8.22], QA: [25.35, 51.18], RO: [45.94, 24.97], RS: [44.02, 21.01],
  RU: [61.52, 105.32], SA: [23.89, 45.08], SE: [60.13, 18.64], SG: [1.35, 103.82],
  SI: [46.15, 14.99], SK: [48.67, 19.70], TH: [15.87, 100.99], TN: [33.89, 9.54],
  TR: [38.96, 35.24], TW: [23.70, 120.96], UA: [48.38, 31.17], UG: [1.37, 32.29],
  US: [37.09, -95.71], UY: [-32.52, -55.77], UZ: [41.38, 64.59], VE: [6.42, -66.59],
  VN: [14.06, 108.28], ZA: [-30.56, 22.94], ZM: [-13.13, 27.85], ZW: [-19.02, 29.15],
};

export function centroidForCountry(code) {
  if (!code) return null;
  const key = String(code).trim().toUpperCase();
  const pair = COUNTRY_CENTROIDS[key];
  if (!pair) return null;
  return { lat: pair[0], lng: pair[1] };
}

export function geoMapPoints(countries = []) {
  const max = Math.max(1, ...countries.map((row) => Number(row.count) || 0));
  return countries
    .map((row, index) => {
      const centroid = centroidForCountry(row._id);
      if (!centroid) return null;
      const count = Number(row.count) || 0;
      return {
        id: `${row._id || 'unknown'}-${index}`,
        code: row._id,
        lat: centroid.lat,
        lng: centroid.lng,
        count,
        radius: Math.max(6, Math.min(22, 6 + Math.sqrt(count / max) * 16)),
        popup: `${row._id}: ${count} session${count === 1 ? '' : 's'}`,
      };
    })
    .filter(Boolean);
}

export function activityUserId(item) {
  if (!item) return null;
  const raw = item.user?._id || (item.user && typeof item.user === 'object' ? null : item.user) || item._id;
  return raw ? String(raw) : null;
}
